import {reactive} from 'vue';
import {
  Tile as TileLayer,
  Group as LayerGroup,
  Vector as VectorLayer,
} from 'ol/layer';
import OSM from 'ol/source/OSM';
import {STYLE_HUELLAS_RUIDO, STYLE_ZSA} from './styles.config-styles';

const DEFAULT_MAP = new TileLayer({
  source: new OSM(),
});

const GROUP_BASE_MAPS = reactive(new LayerGroup({
  layers: [],
  properties: {
    name: 'GROUP_BASE_MAPS',
  },
}));

const GROUP_MINIMAP_MAPS = reactive(new LayerGroup({
  layers: [],
  properties: {
    name: 'GROUP_MINIMAP_MAPS',
  },
}));

const GROUP_OVER_MAPS = reactive(new LayerGroup({
  layers: [],
  properties: {
    name: 'GROUP_OVER_MAPS',
  },
}));

const GROUP_LAYERS = reactive(new LayerGroup({
  layers: [],
  properties: {
    name: 'GROUP_LAYERS',
  },
}));

const GROUP_USER_LAYERS = reactive(new LayerGroup({
  layers: [],
  properties: {
    name: 'USER_LAYERS',
  },
}));

const GROUP_SEARCH = reactive(new LayerGroup({
  layers: [],
  properties: {
    name: 'GROUP_SEARCH',
  },
}));
const GROUP_DRAW = reactive(new LayerGroup({
  layers: [],
  properties: {
    name: 'GROUP_DRAW',
  },
}));
const GROUP_SERVICES = reactive(new LayerGroup({
  layers: [],
  properties: {
    name: 'GROUP_SERVICES',
  },
}));
const GROUP_INTERSECTIONS = reactive(new LayerGroup({
  layers: [
    new VectorLayer({
      source: null,
      style: STYLE_ZSA,
      properties: {
        name: 'LAYER_ZSA',
      },
    }),
    new VectorLayer({
      source: null,
      style: STYLE_HUELLAS_RUIDO,
      properties: {
        name: 'LAYER_HUELLAS',
      },
    }),
  ],
  properties: {
    name: 'GROUP_INTERSECTIONS',
  },
}));

export {
  DEFAULT_MAP,
  GROUP_BASE_MAPS,
  GROUP_MINIMAP_MAPS,
  GROUP_OVER_MAPS,
  GROUP_LAYERS,
  GROUP_USER_LAYERS,
  GROUP_SEARCH,
  GROUP_DRAW,
  GROUP_SERVICES,
  GROUP_INTERSECTIONS,
};
